export enum SetupMode {
  ManualPack = 1,
  AutoBox = 2,
  AutoBag = 3,
  ScaleStation = 4
}
